import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserMovedItemStyles = {
    [key: string]: StylesScene
}
const UserMovedItemStyles: TUserMovedItemStyles = {
    'Group': {
        
    },
    'Public': {
        docTitle: {
            container: {
                position: 'absolute',
                bottom: 354,
                right: 28,
                background: '#fff',
                width: 'auto',
                maxWidth: 270
            },
            text: {
                color: '#0e0e14',
                fontSize: 19,
                textAlign: 'left',
                lineHeight: 1.62,
            }
        },
        dataTypeTag: {
            container: {
                bottom: 80,
                left: 23,
                position: 'absolute',
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 28,
                fontWeight: 800,
                lineHeight: 2,
                letterSpacing: 0,
                color: '#ffd288',
            }
        },
        dataTypeTitle: {
            container: {
                bottom: 23,
                left: 75,
                position: 'absolute',
                width: 250,
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 32,
                fontWeight: 600,
                lineHeight: 1.75,
                letterSpacing: 0,
                color: '#fff',
                textTransform: 'uppercase',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap', 
            }
        },
        mainImg: {
            container: {
                width: 343,
                height: 185,
                position: 'absolute',
                top: 322,
                right: 66,
                borderRadius: 4,
                boxSizing: 'border-box',
                border: '4px solid #fff',
            }
        },
        moveTextFromStatus: {
            container: {
                position: 'absolute',
                top: 185,
                right: 0,
                width: '100%',
                textAlign: 'left',
                padding: '0 15px',
                boxSizing: 'border-box'
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                fontSize: 40,
                fontWeight: 'bold',
                lineHeight: 1.45,
                letterSpacing: 0,
                color: '#fff',
            }
        },
        moveTextToStatus: {
            container: {
                position: 'absolute',
                bottom: 179,
                right: 0,
                width: '100%',
                textAlign: 'right',
                padding: '0 15px',
                boxSizing: 'border-box'
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                fontSize: 40,
                fontWeight: 'bold',
                lineHeight: 1.45,
                letterSpacing: 0,
                color: '#fff',
            }
        },
        groupTitle: {
            container: {
                position: 'absolute',
                top: 94,
                right: 254,
                background: '#fff',
                width: 'auto',
                maxWidth: 200
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000',
            }
        }
    }
}
export const getUserMovedItemBackground = (notif: Notification): [string, StylesScene] => {
    const from = notif.messageTemplateParams[5]
    const to = notif.messageTemplateParams[6]


        if(from === 'Grey' && to === 'Grey' || (!from && !to)) {
            const notificationImgPath = `/${notif.systemActionTypeUid}/${notif.systemActionTypeUid}-Public.png`
            return [notificationImgPath , UserMovedItemStyles[notif.groupType]]
        }  else {
            const notificationImgPath = `/${notif.systemActionTypeUid}/${notif.systemActionTypeUid}-${from}-${to}.png`
            return [notificationImgPath , UserMovedItemStyles[notif.groupType]]
        }
        
} 
